<template>
	<div class="sdk_initaial">
		<document-title-bar :pathData="isPathData"></document-title-bar>
		<h1 class="doc_main_h1">人脸特征比对</h1>
        <h3 class="doc_main_h3">（1）人脸特征比对（String类型特征）</h3>
		<h3 class="doc_main_h3">功能描述</h3>
		<p class="doc_main_p">
			进行两个人脸的1：1特征比对，得出比分相似度分值。
		</p>
		<h3 class="doc_main_h3">函数</h3>
		<pre class="doc_main_pre"><code class="doc_main_code">public float SKFaceFeatureCompare(String FaceFeaA_Base64, String FaceFeaB_Base64)</code></pre>
        <h3 class="doc_main_h3">参数</h3>
        <p class="doc_main_p">（1）FaceFeaA_Base64：第一个人脸的特征字符串</p>
        <p class="doc_main_p">（2）FaceFeaB_Base64：第二个人脸的特征字符串</p>
        <h3 class="doc_main_h3">返回值</h3>
        <p class="doc_main_p">float类型数据，范围[0-1]，值越大表示相似度越高。</p>
		<h3 class="doc_main_h3">示例代码</h3>
		<pre class="doc_main_pre"><code class="doc_main_code">String feaA = "TOgywJ………wuT/vmIDKkA=";// 数据较长，此处仅作示意
String feaB = "KtFEA…………+vkk6JUA=";// 数据较长，此处仅作示意
float compareRes = skFace.SKFaceFeatureCompare(feaA, feaB);</code></pre>
        <h3 class="doc_main_h3">（2）人脸特征比对（byte[] 类型特征）</h3>
		<h3 class="doc_main_h3">功能描述</h3>
		<p class="doc_main_p">
			进行两个人脸的1：1特征比对，得出相似度分值比分。
		</p>
		<h3 class="doc_main_h3">函数</h3>
		<pre class="doc_main_pre"><code class="doc_main_code">public float SKFaceFeatureCompare(byte[] FaceFeaA, byte[] FaceFeaB)</code></pre>
        <h3 class="doc_main_h3">参数</h3>
        <p class="doc_main_p">（1）FaceFeaA：第一个人脸的特征byte[]类型</p>
        <p class="doc_main_p">（2）FaceFeaB：第二个人脸的特征byte[]类型</p>
        <h3 class="doc_main_h3">返回值</h3>
        <p class="doc_main_p">float类型数据，范围[0-1]，值越大表示相似度越高。</p>
		<h3 class="doc_main_h3">示例代码</h3>
		<pre class="doc_main_pre"><code class="doc_main_code">byte[] feaA = {1,1,1,1,1,1,1,1,1,1};// 数据较长，此处仅作示意
byte[] feaB = {1,1,1,1,1,1,1,1,1,1};// 数据较长，此处仅作示意
float compareRes = skFace.SKFaceFeatureCompare(feaA, feaB);</code></pre>
        <h3 class="doc_main_h3">（3）人脸特征byte[]转base64字符串</h3>
		<h3 class="doc_main_h3">功能描述</h3>
		<p class="doc_main_p">
			byte[]转base64字符串。
		</p>
		<h3 class="doc_main_h3">函数</h3>
		<pre class="doc_main_pre"><code class="doc_main_code">public String SKFaceByteArrToBase64Str(byte[] ByteArr)</code></pre>
        <h3 class="doc_main_h3">参数</h3>
        <p class="doc_main_p">ByteArr：要转换的人脸特征byte[]类型</p>
        <h3 class="doc_main_h3">返回值</h3>
        <p class="doc_main_p">转换后的人脸特征Base64字符串类型</p>
		<h3 class="doc_main_h3">示例代码</h3>
		<pre class="doc_main_pre"><code class="doc_main_code">String feaStr = SKFaceByteArrToBase64Str(feaByteArr); //feaByteArr是人脸特征（byte[]类型）</code></pre>
         <h3 class="doc_main_h3">（4）人脸特征base64字符串转byte[]</h3>
		<h3 class="doc_main_h3">功能描述</h3>
		<p class="doc_main_p">
			base64字符串转byte[]。
		</p>
		<h3 class="doc_main_h3">函数</h3>
		<pre class="doc_main_pre"><code class="doc_main_code">public byte[] SKFaceBase64StrToByteArr(String Base64Str)</code></pre>
        <h3 class="doc_main_h3">参数</h3>
        <p class="doc_main_p">Base64Str：要转换的人脸特征String类型</p>
        <h3 class="doc_main_h3">返回值</h3>
        <p class="doc_main_p">转换后的人脸特征byte[]类型</p>
		<h3 class="doc_main_h3">示例代码</h3>
		<pre class="doc_main_pre"><code class="doc_main_code">byte[] feaByteArr = SKFaceBase64StrToByteArr(feaStr); //feaStr是人脸特征（String类型）</code></pre>
        
	</div>
</template>
<script>
	import DocumentTitleBar from '../../../../components/documentTitleBar';
	import AuthorityErrorCode from '../../../../components/authorityErrorCode';
	export default{
		components:{
			'document-title-bar':DocumentTitleBar,
			'authority-error-code':AuthorityErrorCode,
		},
		data(){
			return{
				isPathData:['人脸识别','SKFace-Android','图片接口','人脸特征比对'],
			}
		},
		watch:{

		},
		methods:{

		},
		mounted(){

		}
	}
</script>
<style lang="less" rel="stylesheet/less">
	@import '../../../../less/index.less';
	.sdk_initaial{
	}
</style>	



// WEBPACK FOOTER //
// src/views/documents/skfacesdkandroid/img/Featurecomparison.vue